<div class="pedido-item-desconto-maximo-excedido-table table-responsive">
    <table class="table table-striped table-hover table-bordered" [id]="idTable">
        <thead>
            <tr>
                <th class="col-codigo-item">
                    Cód.
                </th>
                <th class="col-nome-item">
                    Item
                </th>   
                <th class="col-quantidade text-right">
                    Quantidade
                </th>
                <th class="col-perc-desconto text-right">
                    Desc. 1 
                </th>
                <th class="col-perc-desconto text-right">
                    Desc. 2
                </th>      
                <th class="col-perc-desconto-maximo text-right">
                    Desc. Máximo
                </th>           
                <th class="col-valor-liquido text-right">
                    Líquido 
                </th>      
                <th class="col-valor-total text-right">
                    Total
                </th>                                                 
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let pedidoItem of pedidosItens">
                <td class="col-codigo-item" title="{{pedidoItem.codigoIntegracaoErpItem}}">
                    {{pedidoItem.codigoIntegracaoErpItem}}
                </td>
                <td class="col-nome-item" title="{{pedidoItem.nomeItem}}">
                    {{pedidoItem.nomeItem}}
                </td>   
                <td class="col-quantidade text-right" title="{{pedidoItem.quantidade | decimalFormat: 1:3:3}}">
                    {{pedidoItem.quantidade | decimalFormat: 1:3:3}}
                </td>
                <td class="col-perc-desconto text-right" *ngIf="pedidoItem.percDesconto1 ? (pedidoItem.percDesconto1 | decimalFormat: 1:2:2) : ''">
                    <span *ngIf="pedidoItem.percDesconto1">
                        {{pedidoItem.percDesconto1 | decimalFormat: 1:2:2}}%
                    </span>
                </td>
                <td class="col-perc-desconto text-right" title="{{pedidoItem.percDesconto2 ? (pedidoItem.percDesconto2 | decimalFormat: 1:2:2) : ''}}">
                    <span *ngIf="pedidoItem.percDesconto2">
                        {{pedidoItem.percDesconto2 | decimalFormat: 1:2:2}}%
                    </span>
                </td>      
                <td class="col-perc-desconto-maximo text-right" title="{{pedidoItem.percDescontoMaximo ? (pedidoItem.percDescontoMaximo | decimalFormat: 1:2:2): ''}}">
                    <span *ngIf="pedidoItem.percDescontoMaximo">
                        {{pedidoItem.percDescontoMaximo | decimalFormat: 1:2:2}}%
                    </span>
                </td>           
                <td class="col-valor-liquido text-right" title="{{pedidoItem.valorLiquido | currencyFormat: 1:2:2}}">
                    {{pedidoItem.valorLiquido | currencyFormat: 1:2:2}}
                </td>      
                <td class="col-valor-total text-right" title="{{pedidoItem.valorTotal | currencyFormat: 1:2:2}}">
                    {{pedidoItem.valorTotal | currencyFormat: 1:2:2}}
                </td>
            </tr>
        </tbody>
    </table>
</div>